import { ChangeEvent, useRef } from 'react';

export function CatalogImageUploadButton({ label, multiple = false, disabled, onSelect }: { label: string; multiple?: boolean; disabled: boolean; onSelect: (files: File[]) => void }) {
  const input = useRef<HTMLInputElement>(null);
  const select = (event: ChangeEvent<HTMLInputElement>): void => {
    const files = Array.from(event.target.files ?? []);
    if (files.length > 0) onSelect(files);
    event.target.value = '';
  };
  return <>
    <button className="catalog-button" type="button" disabled={disabled} onClick={() => input.current?.click()}>{label}</button>
    <input ref={input} hidden aria-label={label} tabIndex={-1} type="file" accept="image/jpeg,image/png,image/webp" multiple={multiple} disabled={disabled} onChange={select} />
  </>;
}
